import StarRoundedIcon from '@mui/icons-material/StarRounded'
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded'

/**
 * De ster 'extra aandacht', als knop: in de rijen van het huishouden- en het
 * deelnemersoverzicht en in de kop van hun detailpagina's. Een echte <button>
 * met een naam en `aria-pressed`, want een icoon zonder tekst zegt een
 * schermlezer niets, en een hover-tooltip werkt niet op een telefoon.
 * AI-CONTEXT: See docs/pitfalls.md#ui-hover-only-affordance-dies-on-mobile
 * AI-CONTEXT: See docs/features/planner-overzicht-bkb.md
 *
 * @param {object} props
 * @param {boolean} props.starred - Of de ster aanstaat
 * @param {(next: boolean) => void} props.onToggle - Krijgt de nieuwe stand
 * @param {boolean} [props.disabled] - Zonder bewerkrecht: zichtbaar maar niet te wisselen
 * @returns {JSX.Element}
 */
const StarToggle = ({ starred, onToggle, disabled = false }) => (
    <button
        type="button"
        className={`star-toggle${starred ? ' star-toggle--on' : ''}`}
        aria-pressed={starred === true}
        aria-label="Ster: extra aandacht"
        title={starred ? 'Ster weghalen' : 'Ster geven: extra aandacht'}
        disabled={disabled}
        onClick={(e) => {
            // De rij eromheen is soms zelf klikbaar of sleepbaar; de ster
            // hoort die niet mee te nemen.
            e.stopPropagation()
            onToggle(!starred)
        }}
    >
        {starred ? <StarRoundedIcon fontSize="small" /> : <StarBorderRoundedIcon fontSize="small" />}
    </button>
)

export default StarToggle
